import { Component, HostBinding, OnInit } from '@angular/core';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import axios from 'src/app/Service/axios';

import { OtherService } from 'src/app/Service/other.service';

import { Location } from '@angular/common';

import { NotificationService } from 'src/app/Service/notification.service';

import { DataService } from 'src/app/Service/data.service';

import momentJalaali from 'moment-jalaali';

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;

@Component({
  selector: 'entryCar',

  templateUrl: './entryCar.component.html',

  animations: [
    trigger('fadeAnimation', [
      state('void', style({ opacity: 0 })),

      transition(':enter', [animate('300ms ease-in', style({ opacity: 1 }))]),

      transition(':leave', [animate('100ms ease-out', style({ opacity: 0 }))]),
    ]),
  ],
})
export class EntryCarComponent implements OnInit {
  acssess: any;

  carType: any = [];

  carImg: any = [];

  carWork: any;

  gpsType: any = [];

  Id: number = 1;

  selector: boolean = false;

  isLoading: boolean = true;

  carId: number = 0;

  singelCar: any;

  editMod: boolean = false;

  imeIInp: boolean = false;

  bSetSeepad: boolean = false;

  tariffDate: any;

  iOTitle: any;

  IOUsage: any;

  worklyData: any;

  editIoData: any;

  searchT_CarName = '';

  searchT_CarIcon = '';

  searchT_Gps = '';

  filteredCarName = [];

  filteredCarIcon = [];

  filteredGps = [];

  lst_AppUsage: any[] = [];

  lst_MobileDomain: any[] = [];

  lst_OfficialStatus: any[] = [];

  lst_MobileUsage: any[] = [];

  lst_Plate: any[] = [];

  lst_GroupCar: any[] = [];

  sabtModel: FormGroup = this.formBuilder.group({
    tiMobileIcon: new FormControl('-1'),
    tiGPSType: new FormControl(),
    tiMobileType: new FormControl(-1, this.otherService.zeroOrMoreValidator()),
    tiMobileGroup: new FormControl(-1, this.otherService.zeroOrMoreValidator()),
    strFullName: new FormControl(),
    strMobile: new FormControl(),
    strColor: new FormControl(''),
    strVIN: new FormControl(''),
    iYearConstruction: new FormControl(),
    strComment: new FormControl(''),
    strVehicleNo: new FormControl(),
    strValidDate: momentJalaali().format('jYYYY/jMM/01'),
    strDefinationDate: momentJalaali().format('jYYYY/jMM/01'),
    bActive: new FormControl(true),
    bFlowmeter: new FormControl(false),
    bOfficial: new FormControl(false),
    pic: new FormControl(),
    Plak4: new FormControl(),
    Plak3: new FormControl(),
    Plak2: new FormControl('الف'),
    Plak1: new FormControl(),
    strUnitId: new FormControl(),
    bSeepad: new FormControl(),
    strPassword: new FormControl(),
    fLastKM: new FormControl(),
    strVehicleType: new FormControl(''),
    iCode: new FormControl(''),
    tiPassenger: new FormControl('1'),
    tiFuelType: new FormControl('1', this.otherService.zeroOrMoreValidator()),
    tiMobileUsage: new FormControl('-1'),
    tiPlateType: new FormControl('-1'),
    fFuelTankCapacity: new FormControl('0'),
  });

  worklyForm: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    ),
    strSession: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    ),
    strUnitID: new FormControl(),
    strIOTitle: new FormControl('-1'),
    iIOUsage: new FormControl('-1'),
  });

  mdl_GreenPaper: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    ),

    strSession: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    ),

    tiCylinders: new FormControl('4'),

    tiAxis: new FormControl('2'),

    tiWheels: new FormControl('4'),

    strUnitID: new FormControl(''),

    strEngineNumber: new FormControl(''),

    strChassisNumber: new FormControl(''),

    iCylinderVolume: new FormControl('0'),

    strOwnerFullName: new FormControl(''),

    strOwnerFatherName: new FormControl(''),

    strOwnerBirthDate: new FormControl(''),

    strOwnerCertificateNumber: new FormControl(''),

    strOwnerNationalCode: new FormControl(''),

    strOwnerPlaceIssue: new FormControl(''),

    strOwnerPostalCode: new FormControl(''),

    strOwnerAdress: new FormControl(''),
  });

  sabtModelGps: FormGroup = this.formBuilder.group({
    strStartTime: new FormControl('00:00'),
    strEndTime: new FormControl('23:59'),
    bSeepad: new FormControl(),
    bOfficial: new FormControl(),
    tiMobileIcon: new FormControl(),
    tiGPSType: new FormControl(),
    tiMobileType: new FormControl(),
    tiMobileGroup: new FormControl(),
    strFullName: new FormControl(),
    strColor: new FormControl(''),
    strVIN: new FormControl(''),
    strValidDate: momentJalaali().format('jYYYY/jMM/01'),
    strPersonnelID: new FormControl(''),
    strDefinationDate: momentJalaali().format('jYYYY/jMM/01'),
    bActive: new FormControl(true),
    bFlowmeter: new FormControl(false),
    iYearConstruction: new FormControl(0),
    strComment: new FormControl(''),
    strVehicleNo: new FormControl(),
    bIncomplete: new FormControl(),
    pic: new FormControl(),
    fLastKM: new FormControl(''),
    strMobile: new FormControl(''),
    tiMaxSpeed: new FormControl(''),
    strCellNo: new FormControl(''),
    strPassword: new FormControl(''),
    iGPS: new FormControl(),
    fGasPer100_HW: new FormControl(''),
    fMinVoltage: new FormControl('0'),
    strProvinceCode: new FormControl(''),
    fGasPer100_Tr: new FormControl(''),
    fGasPer100: new FormControl(''),
    Plak4: new FormControl(),
    Plak3: new FormControl(),
    Plak2: new FormControl('الف'),
    Plak1: new FormControl(),
    strUnitId: new FormControl(),
    bHasGPS: new FormControl(true),
    bTanker: new FormControl(false),
    bFuelSensor: new FormControl(false),
    bDashCam: new FormControl(false),
    bWeightSensor: new FormControl(false),
    bTemperatureSensor: new FormControl(false),
    bOBD2: new FormControl(false),
    strVehicleType: new FormControl(''),
    iCode: new FormControl(''),
    tiPassenger: new FormControl('1'),
    tiFuelType: new FormControl('1', this.otherService.zeroOrMoreValidator()),
    tiMobileUsage: new FormControl('-1'),
    tiPlateType: new FormControl('-1'),
    fFuelTankCapacity: new FormControl('0'),
  });

  saveTariff: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    ),
    strSession: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    ),
    strUnitID: new FormControl(0),
    iHourlyRate: new FormControl(0),
    iOvertimeRate: new FormControl(0),
    iUrbanOperationRates: new FormControl(0),
    iNonurbanOperatingRates: new FormControl(0),
    iOvernightStopRate: new FormControl(0),
    iIncentiveOvertime: new FormControl(0),
    iIncentiveKm: new FormControl(0),
    strStartTime: new FormControl('7:00'),
    strEndTime: new FormControl('16:00'),
  });

  mdl_AdditionalInfo: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    ),

    strSession: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    ),

    strUnitID: new FormControl(''),

    strPersonnelID: new FormControl(''),

    tiAppUsages: new FormControl('-1'),

    tiOfficialStatus: new FormControl('-1'),

    iMobileDomain: new FormControl('-1'),

    iCode: new FormControl('-1'),

    strBankAccount: new FormControl(''),

    bEnableTimer: new FormControl(false),

    iPeriodSendingLoc: new FormControl(-1),

    iLocationCourseSending: new FormControl(-1),

    strStartTime: new FormControl(''),

    strEndTime: new FormControl(''),

    strManagerMobile: new FormControl(''),

    bCheckPosition4Ready: new FormControl(false),

    bHastrafficLoc: new FormControl(false),

    bHasEvenoddb: new FormControl(false),
  });

  constructor(
    private formBuilder: FormBuilder,

    private _location: Location,

    private router: Router,

    private otherService: OtherService,

    private route: ActivatedRoute,

    private notifyService: NotificationService,

    private dataService: DataService,

    private gurdService: GurdServiceService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.Id = params['id'];

      if (params['Imei']) {
        this.carId = params['Imei'];

        this.saveTariff.controls['strUnitID'].setValue(this.carId);

        this.worklyForm.controls['strUnitID'].setValue(this.carId);

        this.mdl_GreenPaper.controls['strUnitID'].setValue(this.carId);

        this.editMod = true;
      }

      this.getItem();
    });

    this.bSetSeepad = JSON.parse(
      this.gurdService.decrypt(localStorage.getItem('menu') as any),
    ).bSetSeepad;

    setTimeout(() => {
      $('.clockpicker').clockpicker({
        donetext: 'top',
        align: 'top',
        autoclose: true,
      });
    }, 500);

    document.body.onclick = (e: any) => {
      if (
        (e.target.attributes['formcontrolname'] &&
          e.target.attributes['formcontrolname'].value) ||
        e.target.id == 'options'
      ) {
        return;
      } else {
        this.selector = false;
      }
    };

    $('#workly-gps-modal').on('hidden.bs.modal', () => {
      this.worklyForm.controls['strIOTitle'].setValue('-1');

      this.worklyForm.controls['iIOUsage'].setValue('-1');
    });

    var data = window.localStorage.getItem('menu') as any;

    this.acssess = JSON.parse(this.gurdService.decrypt(data));

    // ثبت خودرو اداری

    // ثبت خودرو با ردیاب

    if (this.Id == 1 || this.Id == 3) {
      if (this.Id == 3) this.sabtModelGps.get('bOfficial')?.setValue(true);

      this.sabtModelGps.disable();

      this.sabtModelGps.controls['strUnitId'].enable();

      if (this.carId != 0 && this.carId != null) {
        this.getSingel(this.carId);

        this.sabtModelGps.enable();

        this.imeIInp = true;

        this.isLoading = false;

        this.getTariff();

        this.getIoData();
      }
    } else this.getSingel(this.carId);
  }

  test() {
    $('.clockpicker').clockpicker({
      donetext: 'top',
      align: 'top',
      autoclose: true,
    });
    document.body.onclick = (e: any) => {
      if (
        (e.target.attributes['formcontrolname'] &&
          e.target.attributes['formcontrolname'].value) ||
        e.target.id == 'options'
      ) {
        return;
      } else {
        this.selector = false;
      }
    };
    $('#workly-gps-modal').on('hidden.bs.modal', () => {
      this.worklyForm.controls['strIOTitle'].setValue('-1');
      this.worklyForm.controls['iIOUsage'].setValue('-1');
    });
  }

  getItem = async () => {
    if (!this.editMod) {
      const resp = await axios.post(`GetMobileIcon`);
      this.carImg = resp.data;

      const resp2 = await axios.post(`GetGPSType`);
      this.carType = resp2.data;
    }

    const resp3 = await axios.post(`GetMobileType`);

    this.carWork = resp3.data;

    // ---------------------------------------------------------------

    const resp4 = await axios.post(`GetGPS`);

    this.gpsType = resp4.data;

    // ---------------------------------------------------------------

    const resp5 = await axios.post(`MobileUsage_List`);

    let res = JSON.parse(resp5.data);

    this.lst_MobileUsage = res;

    // ----------------------------------------------------------------

    const resp6 = await axios.post(`PlateType_List`);

    let res6 = JSON.parse(resp6.data);

    this.lst_Plate = res6;

    // ---------------------------------------------------------------

    const resp7 = await axios.post(`GetMobileGroup`, {});

    resp7.data = JSON.parse(resp7.data);

    this.lst_GroupCar = resp7.data;
  };

  deleteIo(iIOMobileUsage: any) {
    $.confirm({
      title: `آیا از حذف این کاربری اطمینان دارید ؟`,
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: 'حذف',
          btnClass: 'btn-success',
          keys: ['enter'],
          action: async () => {
            var model = {
              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
              iSystemUser: this.gurdService.decrypt(
                window.localStorage.getItem('ID')!,
              ),
              iIOMobileUsage: iIOMobileUsage,
            };
            const resp = await axios.post(`IO_DeleteIOMobileUsage`, model);

            let resParse = JSON.parse(resp.data);
            if (resParse.iResult == 0) {
              this.notifyService.showError(resParse.strError);
              return;
            }
            if (resParse.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');
              this.otherService.removeLocalStorage();
              // this.router.navigate(['login']);
              this.router.navigate(['login'], { queryParams: { error: '91' } });

              return;
            } else {
              this.notifyService.showSuccess('با موفقیت حذف شد');
              this.worklyData = this.worklyData.filter((el: any) => {
                return el.iIOMobileUsage != iIOMobileUsage;
              });
            }
            return;
          },
        },
        cancel: {
          text: 'لغو',
        },
      },
    });
  }

  getEditIo = async (iIOMobileUsage: any) => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      iIOMobileUsage: iIOMobileUsage,
    };
    const resp = await axios.post(`IO_GetIOValueTitle`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;
    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '92' } });

      return;
    } else {
      this.editIoData = JSON.parse(resp.data);
    }
    return;
  };

  goBack() {
    this._location.back();
  }

  addWorkly = async () => {
    var model = this.worklyForm.value;
    if (model.iIOUsage == -1) {
      this.notifyService.showError('لطفا کاربری را وارد کنید');
      return;
    }
    if (model.strIOTitle == -1) {
      this.notifyService.showError('لطفا ورودی را وارد کنید');
      return;
    }
    const resp = await axios.post(`IO_AddIOMobileUsage`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;
    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: '93' } });
      // this.router.navigate(['login']);

      return;
    } else {
      this.notifyService.showSuccess('با موفقیت ثبت شد');
      this.worklyData.push(resParse);
      this.worklyForm.controls['strIOTitle'].setValue('-1');
      this.worklyForm.controls['iIOUsage'].setValue('-1');
    }
  };

  getIoData = async () => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strUnitID: this.carId,
    };
    const resp = await axios.post(`IO_GetIOTitle`);
    const resp2 = await axios.post(`IO_GetIOUsage`);
    const resp3 = await axios.post(`IO_GetIOMobileUsage`, model);
    this.iOTitle = JSON.parse(resp.data);
    this.IOUsage = JSON.parse(resp2.data);
    this.worklyData = JSON.parse(resp3.data);
  };

  getSingel = async (Id: any) => {
    if (!Id) return;

    this.otherService.Showspinner();

    const session = encodeURIComponent(
      this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    );

    const resp = await axios.post(
      `GetMobile?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strIMEI=${Id}&strSession=${session}`,
    );

    this.otherService.nonespinner();

    if (resp.data.ISSessionExpired == true) {
      this.notifyService.showError('نشست کاربری شما منقضی شده است!');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '94' } });

      // this.router.navigate(['login']);

      return;
    }

    if (resp.data.iResult == 1) {
      if (this.Id == 1) {
        var interval = setInterval(async () => {
          if (this.carImg) {
            clearInterval(interval);

            this.singelCar = resp.data;

            const resp4 = await axios.post(`GetGPS`);

            this.gpsType = resp4.data;

            this.searchT_Gps = this.gpsType.filter(
              (el: any) => el.iGPS == this.singelCar.iGPS,
            )[0]?.strComment;

            var plak = resp.data.strVehicleNo.split(' ');

            this.otherService.Showspinner();

            const resp2 = await axios.post(`GetGPSType`);

            this.carType = resp2.data;

            this.searchT_CarName = this.carType.filter(
              (el: any) => el.tiGPSType == this.singelCar.tiGPSType,
            )[0]?.strComment;

            const resp3 = await axios.post(`GetMobileIcon`);

            this.carImg = resp3.data;

            this.searchT_CarIcon = this.carImg.filter(
              (el: any) => el.tiMobileIcon == this.singelCar.tiMobileIcon,
            )[0]?.strComment;

            this.otherService.nonespinner();

            var pic = this.carImg.filter((el: any) => {
              return el.tiMobileIcon == `${this.singelCar.tiMobileIcon}`;
            });

            this.sabtModelGps.reset({
              strUnitId: this.singelCar.strUnitId,
              strValidDate: this.singelCar.strValidDate,
              strPersonnelID: this.singelCar.strPersonnelID,
              strDefinationDate: this.singelCar.strDefinationDate,
              bActive: this.singelCar.bActive,
              bFlowmeter: this.singelCar.bFlowmeter,
              tiMobileIcon: this.singelCar.tiMobileIcon,
              tiGPSType: this.singelCar.tiGPSType,
              tiMobileType: this.singelCar.tiMobileType,
              tiMobileGroup: this.singelCar.tiMobileGroup,
              strFullName: this.singelCar.strFullName,
              strColor: this.singelCar.strColor,
              strVIN: this.singelCar.strVIN,
              iYearConstruction: this.singelCar.iYearConstruction,
              strComment: this.singelCar.strComment,
              fLastKM: Math.round(this.singelCar.fLastKM),
              strMobile: this.singelCar.strMobile,
              tiMaxSpeed: this.singelCar.tiMaxSpeed,
              strCellNo: this.singelCar.strCellNo,
              strPassword: this.singelCar.strPassword,
              iGPS: this.singelCar.iGPS,
              fGasPer100_HW: this.singelCar.fGasPer100_HW,
              fMinVoltage: this.singelCar.fMinVoltage,
              strProvinceCode: this.singelCar.strProvinceCode,
              fGasPer100_Tr: this.singelCar.fGasPer100_Tr,
              fGasPer100: this.singelCar.fGasPer100,
              Plak1: plak[0],
              Plak2: plak[1],
              Plak3: plak[2],
              Plak4: plak[4],
              pic: pic[0].strComment,
              bIncomplete: this.singelCar.bIncomplete,
              strStartTime: this.singelCar.strStartTime,
              strEndTime: this.singelCar.strEndTime,
              bSeepad: this.singelCar.bSeepad,
              bOfficial: this.singelCar?.bOfficial,
              strVehicleType: this.singelCar?.strVehicleType,
              iCode: this.singelCar?.iCode,
              tiPassenger: this.singelCar?.tiPassenger,
              tiFuelType: this.singelCar?.tiFuelType,
              tiMobileUsage: this.singelCar?.tiMobileUsage,
              tiPlateType: this.singelCar?.tiPlateType,
              bTanker: this.singelCar?.bTanker,
              bFuelSensor: this.singelCar?.bFuelSensor,
              bDashCam: this.singelCar?.bDashCam,
              bWeightSensor: this.singelCar?.bWeightSensor,
              bTemperatureSensor: this.singelCar?.bTemperatureSensor,
              bOBD2: this.singelCar?.bOBD2,
              fFuelTankCapacity: this.singelCar?.fFuelTankCapacity,
            });

            if (!this.acssess.bEditExpiredDate) {
              this.sabtModelGps.get('fGasPer100_HW')?.disable();

              this.sabtModelGps.get('fGasPer100_Tr')?.disable();

              this.sabtModelGps.get('fGasPer100')?.disable();
            }
          }
        }, 500);
      } else {
        setTimeout(() => {
          this.singelCar = resp.data;

          this.searchT_CarName = this.carType.filter(
            (el: any) => el.tiGPSType == this.singelCar.tiGPSType,
          )[0]?.strComment;

          this.searchT_CarIcon = this.carImg.filter(
            (el: any) => el.tiMobileIcon == this.singelCar.tiMobileIcon,
          )[0]?.strComment;

          var plak = resp.data.strVehicleNo.split(' ');

          var pic = this.carImg.filter((el: any) => {
            return el.tiMobileIcon == `${this.singelCar.tiMobileIcon}`;
          });

          this.sabtModel.reset({
            strUnitId: this.singelCar.strUnitId,
            strDefinationDate: this.singelCar.strDefinationDate,
            bActive: this.singelCar.bActive,
            bFlowmeter: this.singelCar.bFlowmeter,
            bOfficial: this.singelCar.bOfficial,
            strValidDate: this.singelCar.strValidDate,
            tiMobileIcon: this.singelCar.tiMobileIcon,
            tiGPSType: this.singelCar.tiGPSType,
            tiMobileType: this.singelCar.tiMobileType,
            tiMobileGroup: this.singelCar.tiMobileGroup,
            strFullName: this.singelCar.strFullName,
            strColor: this.singelCar.strColor,
            strVIN: this.singelCar.strVIN,
            iYearConstruction: this.singelCar.iYearConstruction,
            strComment: this.singelCar.strComment,
            strMobile: this.singelCar.strMobile,
            bSeepad: this.singelCar.bSeepad,
            fLastKM: this.singelCar.fLastKM,
            Plak1: plak[0],
            Plak2: plak[1],
            Plak3: plak[2],
            Plak4: plak[4],
            pic: pic[0]?.strComment,
            strVehicleType: this.singelCar?.strVehicleType,
            iCode: this.singelCar?.iCode,
            tiPassenger: this.singelCar?.tiPassenger,
            tiFuelType: this.singelCar?.tiFuelType,
            tiMobileUsage: this.singelCar?.tiMobileUsage,
            tiPlateType: this.singelCar?.tiPlateType,
            fFuelTankCapacity: this.singelCar?.fFuelTankCapacity,
          });
        }, 500);
      }
    } else this.notifyService.showError('مشکلی پیش آمده است');
  };

  sabt = async () => {
    var model = this.sabtModel.value;

    if (model.strFullName == null || model.strFullName == '')
      return this.notifyService.showError('لطفا مالک / راننده را مشخص کنید');

    if (model.tiMobileType == null || model.tiMobileType == '')
      return this.notifyService.showError('لطفا نوع خودرو را وارد کنید');

    if (model.tiMobileGroup == null || model.tiMobileGroup == '')
      return this.notifyService.showError('لطفا گروه خودرو را وارد کنید');

    if (model.tiGPSType == null || model.tiGPSType.toString() == '')
      return this.notifyService.showError('لطفا نام خودرو را وارد کنید');

    if (model.iYearConstruction == null || model.iYearConstruction == '')
      return this.notifyService.showError('لطفا سال ساخت خودرو را وارد کنید');

    if (
      model.strMobile == null ||
      model.strMobile == '' ||
      model.strMobile.length != 11
    )
      return this.notifyService.showError('لطفا شماره موبایل را وارد کنید');

    if ((model.strPassword == null || model.strPassword == '') && !this.editMod)
      return this.notifyService.showError('لطفا رمز عبور را وارد کنید');

    if (model.tiMobileIcon == null || model.tiMobileIcon == '')
      model.tiMobileIcon = '-1';

    if (
      model.Plak1 == null ||
      model.Plak1 == '' ||
      model.Plak2 == null ||
      model.Plak2 == '' ||
      model.Plak3 == null ||
      model.Plak3 == '' ||
      model.Plak4 == null ||
      model.Plak4 == ''
    )
      return this.notifyService.showError('لطفا پلاک را وارد کنید');

    model.strVehicleNo = `${model.Plak1} ${model.Plak2} ${model.Plak3} | ${model.Plak4}`;

    $.confirm({
      title: `آیا از ${this.editMod ? ' ویرایش ' : ' ثبت '} اطلاعات اطمینان دارید ؟`,

      content: '',

      type: this.editMod ? 'blue' : 'green',

      buttons: {
        ok: {
          text: this.editMod ? 'ویرایش' : 'ثبت',

          btnClass: this.editMod ? 'btn-primary' : 'btn-success',

          keys: ['enter'],

          action: async () => {
            const session = encodeURIComponent(
              this.gurdService.decrypt(window.localStorage.getItem('Session')!),
            );

            const resp = await axios.post(
              `AddOrEditMobileWithoutGPS?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`,
              this.otherService.stringNumberToNumber(model),
            );

            if (resp.data.ISSessionExpired == true) {
              this.otherService.removeLocalStorage();

              // this.router.navigate(['login']);

              this.router.navigate(['login'], { queryParams: { error: '95' } });

              return;
            }

            if (resp.data == -100) {
              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login']);

              return;
            }

            if (resp.data.iResult == 0 && resp.data.strError)
              return this.notifyService.showError(resp.data.strError);

            this.notifyService.showSuccess('عملیات با موفقیت انجام شد');

            this.router.navigateByUrl(`/carInfo/${resp.data.strUnitId}`);
          },
        },

        cancel: {
          text: 'لغو',
        },
      },
    });
  };

  sabtGps = async () => {
    var model = this.sabtModelGps.value;

    if (model.tiMobileType == null || model.tiMobileType == '') {
      this.notifyService.showError('لطفا نوع خودرو را وارد کنید');
      return;
    }

    if (model.tiMobileGroup == null || model.tiMobileGroup == '') {
      this.notifyService.showError('لطفا گروه خودرو را وارد کنید');
      return;
    }

    if (model.tiGPSType == null || model.tiGPSType.toString() == '') {
      this.notifyService.showError('لطفا نام خودرو را وارد کنید');
      return;
    }

    if (model.tiMobileIcon == null || model.tiMobileIcon == '') {
      this.notifyService.showError('لطفا عکس خودرو را وارد کنید');
      return;
    }

    if (model.strFullName == null || model.strFullName == '') {
      this.notifyService.showError(
        'لطفا نام و نام خانوادگی راننده را وارد کنید',
      );
      return;
    }

    if (model.strMobile == null || model.strMobile == '') {
      this.notifyService.showError('لطفا شماره موبایل راننده را وارد کنید');
      return;
    }

    if (model.tiMaxSpeed == null || model.tiMaxSpeed == '') {
      this.notifyService.showError('لطفا حداکثر سرعت مجاز را وارد کنید');
      return;
    }

    if (
      model.strCellNo == null ||
      (model.strCellNo == '' && this.sabtModelGps.get('iGPS')?.value != 0)
    ) {
      this.notifyService.showError('لطفا شماره سیم کارت ردیاب را وارد کنید');
      return;
    }

    if (
      (model.iGPS == null || model.iGPS == '') &&
      this.sabtModelGps.get('iGPS')?.value != 0
    ) {
      this.notifyService.showError('لطفا نوع gps را وارد کنید');

      return;
    }

    if (model.strPassword == null || model.strPassword == '') {
      this.notifyService.showError('لطفا پسورد را وارد کنید ');
      return;
    }

    if (
      model.strStartTime == null ||
      model.strEndTime == null ||
      model.strStartTime == '' ||
      model.strEndTime == ''
    ) {
      this.notifyService.showError(
        'زمان شروع و پایان ذخیره اطلاعات ردیاب را مشخص کنید',
      );
      return;
    }

    if (
      model.Plak1 == null ||
      model.Plak1 == '' ||
      model.Plak2 == null ||
      model.Plak2 == '' ||
      model.Plak3 == null ||
      model.Plak3 == '' ||
      model.Plak4 == null ||
      model.Plak4 == ''
    ) {
      this.notifyService.showError('لطفا پلاک را وارد کنید');
      return;
    }

    if (!this.acssess.bEditExpiredDate && this.editMod) {
      model.fGasPer100_HW = this.singelCar?.fGasPer100_HW || 0;

      model.fGasPer100_Tr = this.singelCar?.fGasPer100_Tr || 0;

      model.fGasPer100 = this.singelCar?.fGasPer100 || 0;
    }

    model.strVehicleNo = `${model.Plak1} ${model.Plak2} ${model.Plak3} | ${model.Plak4}`;

    let st = document.getElementById('startTime') as any;

    model.strStartTime = st.value;

    let et = document.getElementById('endTime') as any;

    model.strEndTime = et.value;

    this.otherService.Showspinner();

    const session = encodeURIComponent(
      this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    );

    const resp = await axios.post(
      `AddOrEditMobile?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`,
      this.otherService.stringNumberToNumber(model),
    );

    this.otherService.nonespinner();

    if (resp.data.ISSessionExpired == true) {
      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '96' } });

      return this.notifyService.showError('نشست کاربری شما منقضی شده است!');
    }

    if (resp.data == -100) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }

    if (resp.data.iResult == 0 && resp.data.strError != '') {
      this.notifyService.showError(resp.data.strError);
    }

    if (resp.data.iResult == 1) {
      this.notifyService.showSuccess('با موفقیت ثبت شد');

      this.dataService.getData();

      this._location.back();
    }
  };

  setInput(str: any, icon: any) {
    this.sabtModel.controls['pic'].setValue(str);
    this.sabtModel.controls['tiMobileIcon'].setValue(icon);
    this.selector = false;
  }

  setInputGps(str: any, icon: any) {
    this.sabtModelGps.controls['pic'].setValue(str);
    this.sabtModelGps.controls['tiMobileIcon'].setValue(icon);
    this.selector = false;
  }

  show() {
    this.selector = !this.selector;
  }

  off() {
    this.selector = false;
  }

  Imei = async () => {
    var Imei = document.getElementById('Imei') as any;

    if (Imei.value == null || Imei.value == '') {
      this.notifyService.showError('لطفا شناسه را وارد  کنید');
      return;
    }

    const session = encodeURIComponent(
      this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    );

    const resp = await axios.post(
      `GetMobile?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strIMEI=${Imei.value}&strSession=${session}`,
    );

    if (resp.data.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);

      this.router.navigate(['login'], { queryParams: { error: '97' } });

      return;
    }

    if (resp.data.iResult == -2) {
      this.notifyService.showError('این شناسه قبلا استفاده شده است');
    }

    if (resp.data.iResult == 1) {
      ///Handel Edit
      this.getSingel(Imei.value);
    }

    if (resp.data.iResult == -1) {
      this.isLoading = false;
      this.sabtModelGps.enable();
      //this.sabtModelGps.controls['strUnitId'].disable();
      this.imeIInp = true;
      this.sabtModelGps.controls['tiMaxSpeed'].setValue('120');
      this.notifyService.showSuccess('ثبت خودرو بلا مانع است');
    }
  };

  checkNum(e: any) {
    if (isNaN(e.key)) {
      return false;
    }
    return true;
  }

  deleteCar = async () => {
    if (this.Id == 1) {
      var model = this.sabtModelGps.value;
    } else {
      var model = this.sabtModel.value;
    }

    if (confirm('آیا از حذف این خودرو اطمینان دارید')) {
      const session = encodeURIComponent(
        this.gurdService.decrypt(window.localStorage.getItem('Session')!),
      );

      const resp = await axios.post(
        `DeleteMobile?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`,
        model,
      );

      if (resp.data.ISSessionExpired == true) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        // this.router.navigate(['login']);

        this.router.navigate(['login'], { queryParams: { error: '98' } });

        return;
      }

      if (resp.data.iResult == 0) {
        this.notifyService.showError(resp.data.strError);
      }

      if (resp.data.iResult == 1) {
        this.notifyService.showSuccess('با موفقیت حذف شد');
        (this, this.router.navigate(['/']));
      }
    }
  };

  guid() {
    this.otherService.guid(this.Id == 1 ? 11 : 10);
  }

  editTariff = async () => {
    var model = this.saveTariff.value;
    var strStartTime = document.getElementById('Stime') as any;
    var strEndTime = document.getElementById('Etime') as any;
    model.strStartTime = strStartTime.value;
    model.strEndTime = strEndTime.value;
    const resp = await axios.post(`Mobile_EditPriceList`, model);
    var resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;
    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '99' } });

      return;
    } else {
      this.notifyService.showSuccess('با موفقیت ثبت شد');
      this.getTariff();
      $('#tariff').modal('hide');
    }
  };

  getTariff = async () => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strUnitID: this.carId,
    };
    const resp = await axios.post(`Mobile_GetPriceList`, model);
    this.tariffDate = JSON.parse(resp.data);
    this.saveTariff.controls['iHourlyRate'].setValue(
      this.tariffDate.iHourlyRate,
    );
    this.saveTariff.controls['iIncentiveOvertime'].setValue(
      this.tariffDate.iIncentiveOvertime,
    );
    this.saveTariff.controls['iIncentiveKm'].setValue(
      this.tariffDate.iIncentiveKm,
    );
    this.saveTariff.controls['iNonurbanOperatingRates'].setValue(
      this.tariffDate.iNonurbanOperatingRates,
    );
    this.saveTariff.controls['iOvernightStopRate'].setValue(
      this.tariffDate.iOvernightStopRate,
    );
    this.saveTariff.controls['iOvertimeRate'].setValue(
      this.tariffDate.iOvertimeRate,
    );
    this.saveTariff.controls['iUrbanOperationRates'].setValue(
      this.tariffDate.iUrbanOperationRates,
    );
    this.saveTariff.controls['strEndTime'].setValue(this.tariffDate.strEndTime);
    this.saveTariff.controls['strStartTime'].setValue(
      this.tariffDate.strStartTime,
    );
  };

  EditIOValueTitle = async (model: any) => {
    var strValueTitle = document.getElementById(
      `value${model.strValue}`,
    ) as any;
    model.strValueTitle = strValueTitle.value;
    model.iSystemUser = this.gurdService.decrypt(
      window.localStorage.getItem('ID')!,
    );
    model.strSession = this.gurdService.decrypt(
      window.localStorage.getItem('Session')!,
    );
    const resp = await axios.post(`IO_EditIOValueTitle`, model);
    var resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;
    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: '100' } });
      // this.router.navigate(['login']);
      return;
    } else {
      this.notifyService.showSuccess('با موفقیت ثبت شد');
    }
  };

  exit() {
    this.otherService.removeLocalStorage();
    this.router.navigate(['login']);
  }

  filterCarName() {
    if (this.searchT_CarName == '') {
      this.filteredCarName = this.carType;

      this.sabtModel.controls['tiGPSType'].setValue('');

      this.sabtModelGps.controls['tiGPSType'].setValue('');
    } else
      this.filteredCarName = this.carType.filter((item: any) =>
        item.strComment.includes(this.searchT_CarName),
      );
  }

  selectedCarName(item: any) {
    this.sabtModel.controls['tiGPSType'].setValue(item.tiGPSType);

    this.sabtModelGps.controls['tiGPSType'].setValue(item.tiGPSType);

    this.filteredCarName = [];

    this.searchT_CarName = item.strComment;
  }

  filterCarIcon() {
    if (this.searchT_CarIcon == '') {
      this.filteredCarIcon = [];

      this.sabtModel.controls['pic'].setValue('');

      this.sabtModel.controls['tiMobileIcon'].setValue('');

      this.sabtModelGps.controls['pic'].setValue('');

      this.sabtModelGps.controls['tiMobileIcon'].setValue('');
    } else
      this.filteredCarIcon = this.carImg.filter((item: any) =>
        item.strComment.includes(this.searchT_CarIcon),
      );
  }

  selectedCarIcon(item: any, icon: any) {
    this.sabtModel.controls['pic'].setValue(item.tiGPSType);

    this.sabtModel.controls['tiMobileIcon'].setValue(icon);

    this.sabtModelGps.controls['pic'].setValue(item.tiGPSType);

    this.sabtModelGps.controls['tiMobileIcon'].setValue(icon);

    this.filteredCarIcon = [];

    this.searchT_CarIcon = item.strComment;
  }

  filterGps() {
    if (this.searchT_Gps == '') {
      this.filteredGps = [];

      this.sabtModelGps.controls['iGPS'].setValue('');
    } else
      this.filteredGps = this.gpsType.filter((item: any) =>
        item.strComment.includes(this.searchT_Gps),
      );
  }

  selectedGps(item: any) {
    this.sabtModelGps.controls['iGPS'].setValue(item.iGPS);

    this.filteredGps = [];

    this.searchT_Gps = item.strComment;
  }

  generateUnitId = async (isGenerate?: boolean) => {
    // بدون ردیاب

    if (isGenerate) {
      this.otherService.Showspinner();

      const resp = await axios.post(`Mobile_GenerateUnitID`);

      this.otherService.nonespinner();

      (document.getElementById('Imei') as HTMLInputElement).value = resp.data;

      (document.getElementById('gpsInput') as HTMLInputElement).disabled = true;

      (
        document.getElementById('gpsInput') as HTMLInputElement
      ).style.setProperty('background-color', '#fffbeb', 'important');

      this.searchT_Gps = 'بدون ردیاب';

      this.sabtModelGps.get('iGPS')?.setValue(0);

      this.sabtModelGps.get('bHasGPS')?.setValue(false);

      this.sabtModelGps.get('strUnitId')?.setValue(resp.data);

      setTimeout(() => {
        this.Imei();
      }, 100);
    }

    // تحت ردیاب
    else {
      (document.getElementById('Imei') as HTMLInputElement).value = '';

      this.sabtModelGps.disable();

      this.imeIInp = false;

      this.sabtModelGps.controls['strUnitId'].enable();

      this.sabtModelGps.get('bHasGPS')?.setValue(true);

      (document.getElementById('gpsInput') as HTMLInputElement).disabled =
        false;

      (
        document.getElementById('gpsInput') as HTMLInputElement
      ).style.setProperty('background-color', '#FFFFFF', 'important');

      this.searchT_Gps = '';

      this.sabtModelGps.get('iGPS')?.setValue('');
    }
  };

  additionalInfo = async () => {
    let model = {
      ...this.singelCar,

      strUnitID: this.singelCar.strUnitId,
    };

    model.iSystemUser = this.gurdService.decrypt(
      window.localStorage.getItem('ID')!,
    );

    model.strSession = this.gurdService.decrypt(
      window.localStorage.getItem('Session')!,
    );

    this.otherService.Showspinner();

    const resp = await axios.post(
      `Mobile_GetAdditional`,
      this.otherService.stringNumberToNumber(model),
    );

    if (!this.lst_AppUsage.length) this.getAppUsage_List();

    if (!this.lst_MobileDomain.length) this.getMobileDomain();

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    Object.keys(res[0]).forEach((key) => {
      this.mdl_AdditionalInfo.get(key)?.setValue(res[0][key]);
    });

    this.mdl_AdditionalInfo.get('strUnitID')?.setValue(this.carId);

    $('#additionalInfoModal').modal('show');
  };

  editAdditionalInfo() {
    $.confirm({
      title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {
        ok: {
          text: 'ویرایش',

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {
            let STime = document.getElementById('aStartTime') as any;

            this.mdl_AdditionalInfo.get('strStartTime')?.setValue(STime.value);

            let ETime = document.getElementById('aEndTime') as any;

            this.mdl_AdditionalInfo.get('strEndTime')?.setValue(ETime.value);

            this.otherService.Showspinner();

            const resp = await axios.post(
              `Mobile_EditAdditional`,
              this.otherService.stringNumberToNumber(
                this.mdl_AdditionalInfo.value,
              ),
            );

            this.otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.bError) return this.notifyService.showError(res.strError);

            this.notifyService.showSuccess('اطلاعات با موفقیت ویرایش شد');

            $('#additionalInfoModal').modal('hide');
          },
        },

        cancel: {
          text: 'لغو',
        },
      },
    });
  }

  getAppUsage_List = async () => {
    const resp = await axios.post(`AppUsage_List `, {});

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    this.lst_AppUsage = res;
  };

  getMobileDomain = async () => {
    const resp = await axios.post(
      `GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem('ID')!)}`,
      {},
    );

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    this.lst_MobileDomain = res;
  };

  mobile_OfficialStatus = async () => {
    if (!this.lst_OfficialStatus.length) this.getOfficialStatus_List();

    if (this.singelCar.tiOfficialStatus)
      this.mdl_AdditionalInfo
        .get('tiOfficialStatus')
        ?.setValue(this.singelCar.tiOfficialStatus);

    $('#officialStatus_Modal').modal('show');
  };

  getOfficialStatus_List = async () => {
    const resp = await axios.post(`OfficialStatus_List`, {});

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    this.lst_OfficialStatus = res;
  };

  editOfficialStatus = async () => {
    var model = this.otherService.stringNumberToNumber({
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      strUnitID: this.carId,

      tiOffitialStatus: this.mdl_AdditionalInfo.get('tiOfficialStatus')?.value,
    });

    this.otherService.Showspinner();

    const resp = await axios.post(`Mobile_OfficialStatus_Edit`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    this.notifyService.showSuccess('اطلاعات با موفقیت ویرایش شد');

    $('#officialStatus_Modal').modal('hide');
  };

  openGreenPaper_Modal = async () => {
    var model = this.otherService.stringNumberToNumber(
      this.mdl_GreenPaper.value,
    );

    this.otherService.Showspinner();

    const resp = await axios.post(`Mobile_GreenPaper_Info`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    if (res.length) {
      Object.keys(res[0]).forEach((key) => {
        this.mdl_GreenPaper.get(key)?.setValue(res[0][key]);
      });
    }

    $('#greenPaper_Modal').modal('show');
  };

  submit_GreenPaper = async () => {
    var model = this.otherService.stringNumberToNumber(
      this.mdl_GreenPaper.value,
    );

    this.otherService.Showspinner();

    const resp = await axios.post(`Mobile_GreenPaper_Update`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    this.notifyService.showSuccess('عملیات با موفقیت انجام شد');

    $('#greenPaper_Modal').modal('hide');
  };

  analyzeVoltage = async () => {
    var model = this.otherService.stringNumberToNumber({
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
      strUnitID: this.carId,
    });

    this.otherService.Showspinner();
    const resp = await axios.post(`MobileHistory_GetPowerMinMaxBySpeed`, model);
    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res == -1) {
      return this.notifyService.showError('تحلیل ناموفق');
    }

    if (res.bError) {
      return this.notifyService.showError(res.strError);
    }

    this.sabtModelGps.patchValue({
      fMinVoltage: res,
    });
  };
}
